import { defineStore } from 'pinia'

export default defineStore({
  id: 'data',
  state: () => ({
    businesses: [],
    tasks: [],
    vehicleCategories: [],
    drivers: [],
    tollStationStructure: {} as { [key: string]: any }
  }),
  actions: {
    clear () {
      this.businesses = []
      this.tasks = []
      this.vehicleCategories = []
      this.drivers = []
      this.tollStationStructure = {}
    },
    setBusinesses (payload: any) {
      this.businesses = payload || []
    },
    setTasks (payload: any) {
      this.tasks = payload || []
    },
    setDrivers (payload: any) {
      this.drivers = payload || []
    },
    setTollStationStructure (payload: any) {
      this.tollStationStructure = payload || null
    },
    setVehicleCategories (payload: any) {
      this.vehicleCategories = payload || []
    }
  },
  getters: {
    getBusinesses: (state) => state.businesses,
    getTasks: (state) => state.tasks,
    getDrivers: (state) => state.drivers,
    getVehicleCategories: (state) => state.vehicleCategories,
    getTollStationStructure: (state) => state.tollStationStructure
  }
})
